import Immutable from 'immutable';
import {
  SHOW_SUBSCRIBE_AS_EDUCATOR_MODAL,
  TRIAL_COUNTDOWN_BANNER_CLICK,
  CLOSE_SUBSCRIBE_AS_EDUCATOR_MODAL,
  UPGRADE_EDUCATOR_TRIAL_SUBSCRIPTION_CLICK,
} from './actions';
import { SUBSCRIPTION_PAYMENT_START } from '../PaymentTransaction/SubscriptionTransaction/actions';
import { CREATE_COURSE_FAILURE_NON_EDUCATOR } from '../Courses/actions';

const initialState = Immutable.fromJS({
  showSubscribeAsEducatorModal: false,
  canDismissSubscribeAsEducatorModal: false,
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function EducatorSubscriptions(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_SUBSCRIBE_AS_EDUCATOR_MODAL:
    case CREATE_COURSE_FAILURE_NON_EDUCATOR: {
      let newState = state;
      newState = newState.set('showSubscribeAsEducatorModal', true);
      newState = newState.set('canDismissSubscribeAsEducatorModal', false);
      return newState;
    }
    case TRIAL_COUNTDOWN_BANNER_CLICK:
    case UPGRADE_EDUCATOR_TRIAL_SUBSCRIPTION_CLICK: {
      let newState = state;
      newState = newState.set('showSubscribeAsEducatorModal', true);
      newState = newState.set('canDismissSubscribeAsEducatorModal', true);
      return newState;
    }
    case CLOSE_SUBSCRIBE_AS_EDUCATOR_MODAL: {
      return state.set('showSubscribeAsEducatorModal', false);
    }
    case SUBSCRIPTION_PAYMENT_START: {
      const { subscriptionData } = action;
      if (subscriptionData.get('type') === 'educator') {
        return state.set('canDismissSubscribeAsEducatorModal', false);
      }
      return state;
    }
    default: {
      return state;
    }
  }
}
